import type { TJsonQuery } from '../../../packages/JsonQuery';
import type { IAppState } from '../../common/state';

export function selectJsonQuery(state: IAppState): TJsonQuery {
  return state.results.jsonQuery;
}
